import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren, OnChanges } from '@angular/core';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { GuestService } from 'src/app/shared/services/guest.service';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { DynamicFormService } from 'src/app/shared/dynamicform/service/dynamic-form.service';
import { DynamicFormComponent } from 'src/app/shared/dynamicform/dynamic-form/dynamic-form.component';
import { fieldType, NoteType } from 'src/app/shared/constants/commonenums';
import { CustomFieldsDTO, SecondaryContactDTO, RequiredPartyFields } from 'src/app/shared/Models/PartyModels';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-activities-lite-secondary-guest-data',
    templateUrl: './activities-lite-secondary-guest-data.component.html',
    styleUrls: ['./activities-lite-secondary-guest-data.component.scss'],
    standalone: false
})
export class ActivitiesLiteSecondaryGuestDataComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() secondaryGuestDetail: SecondaryContactDTO;
  @Input() customGuestFields;
  @Input() selectedActivity;
  @Input() secondaryGuestCount;
  @Input() restaurantDetail;
  @Input() secondaryGuestVisibileFields;
  @Input() noteType: number;
  @Input() stayGuestList: any = [];
  @Input() isNewGuest:boolean = false;
  secondaryGuestConfig: FieldConfig[] = [];
  @ViewChildren('form') secondaryGuestForm: QueryList<DynamicFormComponent>;
  @Output() secondaryGuestNotes = new EventEmitter<any>();
  @Output() deleteSecondaryGuest = new EventEmitter<any>();
  @Output() secondaryGuestData = new EventEmitter<any>();
  mobileNumberLength: number = 10;
  customGuestFieldsMappingValidations: any = [];
  customGuestFieldsLoad: boolean = false;
  notesData: any[] = [];
  mobileMandatoryValues = false;
  showNotes: boolean = false;
  SelectedGuestToFillIn: any = {};
  showPerferenceNotes : boolean = false;
  constructor(private ts: TranslateService, public guestService: GuestService, private dynamicForm: DynamicFormService) { }

  ngOnInit(): void {
    this.showPerferenceNotes = this.noteType == NoteType.partyNote ? false : true
    this.customGuestFieldsMappingValidations = this.restaurantDetail?.customGuestFieldsMappingValidations;
    this.createSecondaryGuestConfig();
    this.createCustomFieldsConfig();
  }

  createSecondaryGuestConfig() {
    let data = this.secondaryGuestDetail;
    // if (this.secondaryGuestVisibileFields?.showGuestNames) {
      this.secondaryGuestConfig.push({
        type: 'input',
        name: 'FirstName',
        label: this.ts.instant('firstName'),
        inputType: 'text',
        showErrorText: true,
        isFormArray: false,
        errorMessage: this.ts.instant('firstNameRequired'),
        validation: data?.IsSystemGenerated ? [] : [Validators.required, Validators.minLength(this.guestService.ContactMinLength ?? 2)],
        value: (data && data.FirstName) ? data.FirstName : '',
        appearanceOutline: true,
        charLength: this.guestService.ContactMinLength ?? 2,
        hide: !this.secondaryGuestVisibileFields?.showGuestNames
      },
        {
          type: 'input',
          label: this.ts.instant('lastName'),
          name: 'LastName',
          inputType: 'text',
          showErrorText: true,
          isFormArray: false,
          errorMessage: this.ts.instant('lastNameRequired'),
          value: (data && data.LastName) ? data.LastName : '',
          appearanceOutline: true,
          validation: data?.IsSystemGenerated ? [] : [Validators.required, Validators.minLength(this.guestService.ContactMinLength ?? 2)],
          charLength: this.guestService.ContactMinLength ?? 2,
          hide: !this.secondaryGuestVisibileFields?.showGuestNames
        },
        {
          type: 'input',
          label: this.ts.instant('aliasName'),
          name: 'AliasName',
          inputType: 'text',
          showErrorText: true,
          isFormArray: false,
          value: (data && data.AliasName) ? data.AliasName : '',
          validation: [],
          appearanceOutline: true,
          hide: !this.guestService?.widgetSettings?.ShowAliasName && !this.secondaryGuestVisibileFields?.showGuestNames
        }
        )
    // }
    // if (this.secondaryGuestVisibileFields?.showprimaryContacts) {
      this.secondaryGuestConfig.push({
        type: 'select',
        name: 'CountryId',
        inputType: 'number',
        class: 'guest-view__mobile-code-edit',
        options: this.guestService.countriesList ? this.guestService.countriesList.map(element => {
          return { id: element.Id, value: element.CountryPhoneCode + '  (' + element.Name + ' )' }
        }) : [],
        value: (data && data.CountryId) ? data.CountryId : Utilities.getDefaultCountry(this.guestService.countriesList ? this.guestService.countriesList : [], this.restaurantDetail.Country).Id,
        validation: [Validators.required],
        isFormArray: false,
        appearanceOutline: true,
        hide: !this.secondaryGuestVisibileFields?.showprimaryContacts
      },
        {
          type: 'input',
          name: 'PhoneNumber',
          inputType: 'text',
          label: this.ts.instant('mobile'),
          directive: 'numberOnly',
          showErrorText: true,
          isFormArray: false,
          value: (data && data.PhoneNumber) ? data.PhoneNumber : null,
          appearanceOutline: true,
          isMandatory: true,
          validation: [],
          numberFormat: 'phoneNumber',
          hide: !this.secondaryGuestVisibileFields?.showprimaryContacts
        },
        {
          type: 'input',
          label: this.ts.instant('email'),
          name: 'EmailAddress',
          inputType: 'email',
          showErrorText: true,
          isFormArray: false,
          errorMessage: this.ts.instant('emailRequired'),
          validation: [Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$')],
          value: (data && data.EmailAddress) ? data.EmailAddress : null,
          appearanceOutline: true,
          hide: !this.secondaryGuestVisibileFields?.showprimaryContacts
        })
    // }
    this.secondaryGuestConfig = this.requireFliedValidation(this.restaurantDetail.RequiredSecondaryGuestFields, this.secondaryGuestConfig);
  }

  ngOnChanges(changes) {
    console.log(this.noteType);
    
    this.notesData = this.secondaryGuestDetail?.Notes || [];
    this.showNotes = this.secondaryGuestVisibileFields?.showNotes || false;
  }

  ngAfterViewInit() {
    this.getFormValue();
    this.getSecondaryGuestDetails();
  }

  SelectedGuestToFillInChangeHandler(){
    // this.secondaryGuestDetail = this.SelectedGuestToFillIn;
    //🐞 Bug Fix | Issue: 49235 | Root: Error is displayed when creating a guest without selecting details from the pre-populated dropdown | Fix: Validation added to check if guest is selected | By: Jeba Sherin | Date: 11/02/2026
    Object.keys(this.SelectedGuestToFillIn).forEach(secondaryGuestData => {
      this.secondaryGuestDetail[secondaryGuestData] = this.SelectedGuestToFillIn[secondaryGuestData];
    });
    this.secondaryGuestDetail.isValid = true; 
    
    if(this.secondaryGuestForm.last?.form){
      this.secondaryGuestForm.last.form.get('FirstName').setValue(this.secondaryGuestDetail.FirstName);
      this.secondaryGuestForm.last.form.get('LastName').setValue(this.secondaryGuestDetail.LastName);
      this.secondaryGuestForm.last.form.get('AliasName').setValue(this.secondaryGuestDetail.AliasName);
      //🐞 Bug Fix | Issue: 49238 | Root: CountryId becomes undefined when guest is chosen from dropdown | Fix: when countryId is undefined, get the default country | By: Jeba Sherin | Date: 11/02/2026
      const countryId = this.secondaryGuestDetail.CountryId || Utilities.getDefaultCountry(this.guestService.countriesList, this.restaurantDetail.Country)?.Id;
      this.secondaryGuestForm.last.form.get('CountryId').setValue(countryId);
      this.secondaryGuestForm.last.form.get('PhoneNumber').setValue(this.secondaryGuestDetail.PhoneNumber);
      this.secondaryGuestForm.last.form.get('EmailAddress').setValue(this.secondaryGuestDetail.EmailAddress); 
    }
    let guestFields = ['FirstName','LastName','AliasName','CountryId','PhoneNumber','EmailAddress'];
    if(this.SelectedGuestToFillIn.GuestProfileServiceId === -1){
     this.enableGuestDetails(guestFields);
    }
    else{
      this.disableGuestDetails(guestFields);
    }
  }
   enableGuestDetails(guestFields){
    guestFields.forEach( field=> {
      this.secondaryGuestForm.last.form.get(field).enable();
    });
  }
  disableGuestDetails(guestFields){
    guestFields.forEach( field=> {
      this.secondaryGuestForm.last.form.get(field).disable();
    });
  }
  getFormValue() {
    if (this.secondaryGuestForm.first.form) {
      this.countryCodeChange();
      this.applySecondaryGuestControlState();
      this.secondaryGuestForm.first.form.valueChanges.pipe(debounceTime(500),
      distinctUntilChanged()).subscribe(data => {
        this.getSecondaryGuestDetails();
        if (data.CountryId) {
          this.countryCodeChange()
        }
        if (data.PhoneNumber) {
          this.mobileNumberChange()
        }
      })
    }
    if (this.secondaryGuestForm.last.form) {
      this.secondaryGuestForm.last.form.valueChanges.pipe(debounceTime(500),
      distinctUntilChanged()).subscribe(data => {
        this.getSecondaryGuestDetails();
        this.secondaryGuestForm.last.form.get('FirstName').setValidators( [Validators.required, Validators.minLength(this.guestService.ContactMinLength ?? 2)]);
        this.secondaryGuestForm.last.form.get('LastName').setValidators( [Validators.required, Validators.minLength(this.guestService.ContactMinLength ?? 2)]);
      })
    }
  }

  private applySecondaryGuestControlState() {
    const form = this.secondaryGuestForm?.first?.form;
    if (!form) return;

    const disableGuestNameFields = this.guestService.IsStayGuest || this.guestService.IsMember;
    ['FirstName', 'LastName', 'AliasName'].forEach(field => {
      const control = form.get(field);
      if (!control) return;
      disableGuestNameFields ? control.disable({ emitEvent: false }) : control.enable({ emitEvent: false });
    });

    ['CountryId', 'PhoneNumber', 'EmailAddress'].forEach(field => {
      const control = form.get(field);
      if (!control) return;
      this.guestService.IsMember ? control.disable({ emitEvent: false }) : control.enable({ emitEvent: false });
    });
  }

  getSecondaryGuestDetails() {
    let guest = Object.assign(this.secondaryGuestForm.last.form.getRawValue());
    let secondaryContact = {
      FirstName: guest.FirstName,
      LastName: guest.LastName,
      AliasName: guest.AliasName,
      EmailAddress: guest.EmailAddress ? guest.EmailAddress : null,
      PhoneNumber: guest.PhoneNumber ? guest.PhoneNumber : null,
      CountryId: guest.CountryId,
      ContactCustomFields: this.bindCustomGuestFieldsValue(),
      PartyId: this.secondaryGuestDetail.PartyId ? this.secondaryGuestDetail.PartyId : null,
      Id: this.secondaryGuestDetail.Id || null,
      GuestProfileServiceId: this.secondaryGuestDetail.GuestProfileServiceId != "-1" ? this.secondaryGuestDetail.GuestProfileServiceId || null : null, 
      ContactNotes: guest.ContactNotes ? guest.ContactNotes : null,
      Notes: this.notesData,
      isValid: this.guestService.IsStayGuest || this.guestService.IsMember ? true : this.secondaryGuestForm?.last?.form?.valid,
      count: this.secondaryGuestDetail.count,
    }
    this.secondaryGuestData.emit(secondaryContact);
  }
  bindCustomGuestFieldsValue() {
    let CustomFieldsList: CustomFieldsDTO[] = [];
    if (this.customGuestFields && this.customGuestFields.length > 0) {
      this.customGuestFields.forEach((field) => {
        if (this.secondaryGuestForm.first.form.value['customField_' + field.Id.toString()] != null) {
          let customField = new CustomFieldsDTO();
          customField.CustomFieldId = Number(field.Id);
          customField.CustomFieldValue = this.secondaryGuestForm.first.form.value['customField_' + field.Id.toString()];
          customField.CustomFieldName = field.FieldName;
          CustomFieldsList.push(customField);
        }
      })
    }
    return CustomFieldsList;
  }

  toggleSelection(noteOptions) {
    this.secondaryGuestNotes.emit({ noteOptions: noteOptions });
    this.getSecondaryGuestDetails();
  }

  countryCodeChange() {
    if (this.secondaryGuestVisibileFields?.showprimaryContacts) {
      let countryCode = this.secondaryGuestForm.first.form.get('CountryId').value;
      if (countryCode) {
        const selectedCountryCode = this.guestService.countriesList.find((country) => {
          return country.Id === countryCode;
        });
        this.guestService.selectedCountryId = selectedCountryCode.Id;
        this.dynamicForm.selectedCountryCode = selectedCountryCode.CountryPhoneCode;
        this.changeMobileLength();
        this.mobileNumberChange();
      }
    }
  }

  mobileNumberChange() {
    if (this.secondaryGuestVisibileFields?.showprimaryContacts) {
      let mobileNumber = this.secondaryGuestForm.first.form.get('PhoneNumber').value;
      if (mobileNumber) {
        mobileNumber = this.dynamicForm.onInputChange(mobileNumber, false);
      }
      this.changeMobileLength();
      this.secondaryGuestForm.first.form.get('PhoneNumber').setValue(mobileNumber, { emitEvent: false });
    }
  }

  changeMobileLength() {
    if (this.secondaryGuestVisibileFields?.showprimaryContacts && this.dynamicForm.requiredPhoneNumberLength$) {
      const count = this.dynamicForm.requiredPhoneNumberLength$;
      this.mobileNumberLength = count;
      this.secondaryGuestForm.first.form.controls['PhoneNumber'].setValidators(this.mobileMandatoryValues ? [Validators.required, Validators.minLength(this.mobileNumberLength), Validators.maxLength(this.mobileNumberLength)] : [Validators.minLength(this.mobileNumberLength), Validators.maxLength(this.mobileNumberLength)]);
      this.secondaryGuestForm.first.form.updateValueAndValidity({ emitEvent: false });
    }
  }

  deleteSecondary(guestDetail) {
    this.deleteSecondaryGuest.emit(({
      index: guestDetail.count,
      contactId: guestDetail.ContactId
    }));
  }

  createCustomFieldsConfig() {
    if (this.customGuestFields) {
      this.customGuestFields.map((customField, index) => {
        let fieldConfig: FieldConfig;
        if (this.showCustomFieldBasedOnActivity(customField.Id)) {
          if (customField.FieldType == fieldType[0]) {
            fieldConfig = {
              type: 'input',
              name: `customField_${customField.Id}`,
              inputType: 'text',
              label: customField.FieldName,
              placeholder: customField.FieldDescription,
              class: 'guest-view__custom-fields-edit',
              id: customField.Id,
              isFormArray: false,
              appearanceOutline: true,
              value: this.getCustomGuestFieldsValue(customField.Id, fieldType[0]),
              validation: this.customValidationRequired(customField),
              hide: !this.secondaryGuestVisibileFields.showCustomFields
            };
          } else if (customField.FieldType == fieldType[1]) {
            let Options = [];
            Options = customField.FieldOptions.split(',').map(x => { return { id: x, value: x } });
            fieldConfig = {
              type: 'select',
              label: customField.FieldName,
              name: `customField_${customField.Id}`,
              placeholder: customField.FieldDescription,
              options: Options,
              class: 'guest-view__custom-fields-edit',
              id: customField.Id,
              isFormArray: false,
              appearanceOutline: true,
              value: this.getCustomGuestFieldsValue(customField.Id, fieldType[1]),
              validation: this.customValidationRequired(customField),
              hide: !this.secondaryGuestVisibileFields.showCustomFields
            }
          }
          if (fieldConfig) {
            this.secondaryGuestConfig.push(fieldConfig);
          }
        }
      })
    }
    this.customGuestFieldsLoad = true;
  }

  showCustomFieldBasedOnActivity(customFieldId) {
    let specialMealId = (this.selectedActivity && this.selectedActivity.SpecialMealId) ? this.selectedActivity?.SpecialMealId : -1;
    let activitiesCustomGuestFields = this.customGuestFieldsMappingValidations;
    if (activitiesCustomGuestFields.find(activity => activity.ActivityId == specialMealId)) {
      let activeActivity = activitiesCustomGuestFields.find(activity => activity.ActivityId == specialMealId)
      if (activeActivity.CustomFields.filter(field => field.FieldId === customFieldId && field.AvailableForWebReservation == true)?.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false
    }
  }

  getCustomGuestFieldsValue(Id, type) {
    let customValue;
    if (this.secondaryGuestDetail && this.secondaryGuestDetail.ContactCustomFields && this.secondaryGuestDetail.ContactCustomFields.length) {
      customValue = this.secondaryGuestDetail.ContactCustomFields.find(field => field.CustomFieldId === Id)
    }
    return type == fieldType[0] ? (customValue ? customValue['CustomFieldValue'] : '') : (customValue ? customValue['CustomFieldValue'] : '');
  }

  customValidationRequired(field) {
    if (this.customFieldMandatory(field)) {
      return [Validators.required];
    } else {
      return [];
    }
  }

  customFieldMandatory(field) {
    let specialMealId = (this.selectedActivity && this.selectedActivity.SpecialMealId) ? this.selectedActivity?.SpecialMealId : -1;
    let activitiesCustomGuestFields = this.customGuestFieldsMappingValidations;
    let CustomFields = activitiesCustomGuestFields.find(activity => activity.ActivityId == specialMealId)?.CustomFields;
    let validations = CustomFields?.find(customField => customField?.FieldId === field?.Id)?.Validations;
    if (validations?.length > 0) {
      return true;
    }
    else {
      return false;
    }
  }
  requireFliedValidation(RequiredFields, fieldConfig) {
    if (this.secondaryGuestVisibileFields?.showprimaryContacts) {
      const phoneIndex = fieldConfig.findIndex(x => x.name.toLowerCase() === 'phonenumber');
      const emailIndex = fieldConfig.findIndex(x => x.name.toLowerCase() === 'emailaddress');
      const emailPattern = [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$')]
      let mobileMandatoryValues = [RequiredPartyFields.All, RequiredPartyFields.Both, RequiredPartyFields.Anyone, RequiredPartyFields.PhoneNumber, RequiredPartyFields.PhoneNumberEmailAddressSecEmailAddress, RequiredPartyFields.PhoneNumberEmailAddressSecPhoneNumber, RequiredPartyFields.PhoneNumberSecEmailAddress];
      let emailMandatoryValues = [RequiredPartyFields.All, RequiredPartyFields.Both, RequiredPartyFields.Anyone, RequiredPartyFields.EmailAddress, RequiredPartyFields.EmailAddressSecEmailAddress, RequiredPartyFields.EmailAddressSecPhoneNumber, RequiredPartyFields.EmailAddressSecPhoneNumberSecEmailAddress, RequiredPartyFields.PhoneNumberEmailAddressSecEmailAddress, RequiredPartyFields.PhoneNumberEmailAddressSecPhoneNumber];
      if (mobileMandatoryValues.includes(RequiredFields)) {
        this.mobileMandatoryValues = true;
        fieldConfig[phoneIndex].validation = [Validators.required];
        fieldConfig[phoneIndex].showErrorText = true;
        fieldConfig[phoneIndex].errorMessage = 'guestBookDetailsMobileError';

      }
      if (emailMandatoryValues.includes(RequiredFields)) {
        fieldConfig[emailIndex].validation = emailPattern;
        fieldConfig[emailIndex].showErrorText = true;
        fieldConfig[emailIndex].errorMessage = 'guestBookDetailsEmailError';

      }
    }
    return fieldConfig
  }

}
